export default __webpack_public_path__ + "static/103-43db155bc097dd4efe17fc59a2d8cda1.gif";